import Vue from 'vue';
import Router from 'vue-router';
import HomeView from './views/HomeView';
import ProfileView from './views/ProfileView';
// const ProfileView = () => import('./views/ProfileView.vue');
const Skill_ProgramView = () => import('./views/SkillProgram');
const Skill_OthersView = () => import('./views/SkillOthers');
const ProductionView = () => import('./views/ProductionView');

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'index',
            component: HomeView,
            redirect:'/home/',
        },
        {
            path: '/home/',
            name: 'home',
            component: HomeView,
            meta: { title: 'Home', desc: 'ホーム画面' }
        },
        {
            path: '/profile/',
            name: 'profile',
            component: ProfileView,
            meta: { title: 'Profile', desc: 'プロフィール画面' }
        },
        {
            path: '/skill/programming/',
            name: 'skill_program',
            component: Skill_ProgramView,
            meta: { title: 'Skills', desc: 'スキル一覧画面' }
        },
        {
            path: '/skill/others/',
            name: 'skill_others',
            component: Skill_OthersView,
            meta: { title: 'Skill Others', desc: 'スキル画面（テスト）' }
        },
        {
            path: '/productions/',
            name: 'productions',
            component: ProductionView,
            meta: { title: 'Productions', desc: '制作物一覧画面' }
        },
    ],
    // 遷移時に最上部までスクロールする。進む・戻るの場合はそのままの高さにする
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
           return savedPosition
        } else {
           return { x: 0, y: 0 }
        }
      }
});

